'use strict';

import { logger } from '../logger';

export function setGestureState() {
  logger.warn('setGestureState() is not available on web.');
}
